module.exports = __webpack_public_path__ + "img/education.1e8344dc.svg";